import { rootRoute } from '../root';
import { on, off } from '@acng/frontend-bounty';
export function atRouteDirective() {
    return {
        scope: false,
        terminal: true,
        transclude: 'element',
        priority: 700,
        restrict: 'A',
        controller: ['$scope', '$element', '$attrs', '$transclude', '$animate', controller],
    };
}
function controller($scope, $element, $attr, $transclude, $animate) {
    let childScope;
    let childElement;
    const element = $element[0];
    const matches = /^\s*(?<not>!)?\s*(?<name>\w+)/.exec($attr['atRoute']);
    const not = !!matches?.groups?.not;
    /** The route name */
    const name = matches?.groups?.name;
    const route = name ? rootRoute.find(name) : null;
    // We need a route object from here on. Without the route we can't do anything.
    if (!route) {
        DEBUG: console.warn(`voyager/ng/at-route "${name}" not found`);
        return;
    }
    const listener = (routeEvent) => {
        /** `true` when Voyager went async, `false` otherwhise */
        const goneAsync = routeEvent.detail.goneAsync;
        DEBUG: route.VERBOSE && console.debug(`voyager/ng/at-route "${name}" change #${$scope.$id} %O`, { routeEvent, goneAsync });
        // Keep it in sync, respecting the current ($locationChange) digest.
        if (!goneAsync) {
            change();
        }
        else {
            $scope.$apply(change);
        }
        // But maybe it is always better to go async.
        // $scope.$applyAsync(change);
    };
    const change = () => {
        if (route.isActive) {
            not ? leave() : enter();
        }
        else {
            not ? enter() : leave();
        }
    };
    const enter = () => {
        if (childScope) {
            // elements are already there
            if (!not) {
                for (const i in route.params) {
                    childScope[i] = route.params[i];
                }
            }
            return;
        }
        $transclude((clone, newScope) => {
            if (!clone || !newScope) {
                throw new Error('something went wrong');
            }
            childScope = newScope;
            childElement = clone;
            if (!not) {
                for (const i in route.params) {
                    childScope[i] = route.params[i];
                }
            }
            DEBUG: route.VERBOSE && console.debug(`voyager/ng/at-route "${name}" enter #${$scope.$id}`, { childElement });
            // @ts-expect-error angular-animate lib is bad
            $animate.enter(childElement, null, element);
        });
    };
    const leave = () => {
        DEBUG: route.VERBOSE && console.debug(`voyager/ng/at-route "${name}" leave #${$scope.$id}`);
        if (childScope) {
            childScope.$destroy();
            childScope = undefined;
        }
        if (childElement) {
            $animate.leave(childElement);
            childElement = undefined;
        }
    };
    on(route, 'change', listener);
    $scope.$on('$destroy', () => off(route, 'change', listener));
    change();
}
